export default __webpack_public_path__ + "assets/valeclin-component.15e4560f.svg";